<template>
    <div>
        <Popup v-model="popupShow" closeable close-icon-position="top-right" @close="close" style="width: 90%">
            <div v-if="notice.type=='Install'">
                <NavBar title="报装通知"/>
                <div style="padding: 5px">
                    <div>产品名称:{{device.productName}}</div>
                    <div>设备名称:{{device.name}}</div>
                    <div>设备编号:{{device.sn}}</div>
                    <div>安装区域:{{device.areaName}}</div>
                    <div>所属项目:{{device.unitName}}</div>
                    <div>详细地址:{{device.address}}</div>
                    <div>安装地址:{{device.installLocation}}</div>
                    <div>安装时间:{{device.createdTime}}</div>
                </div>
            </div>
            <div v-else-if="notice.type=='Alarm'">
                <NavBar title="告警消息"/>
                <div style="padding: 20px">
                    <div style="padding: 5px">告警原因:{{alarm.eventName}}</div>
                    <div style="padding: 5px">告警时间:{{alarm.time}}</div>
                    <div style="padding: 5px">设备名字:{{alarm.deviceName}}</div>
                    <div style="padding: 5px">设备编号:{{alarm.deviceSn}}</div>
                    <div style="padding: 5px">所属区域:{{alarm.areaName}}</div>
                    <div style="padding: 5px">详细地址:{{alarm.deviceAddress}}</div>
                    <div style="padding: 5px">所属项目:{{alarm.unitName}}</div>
                </div>
            </div>
            <div v-else>
                <NavBar title="系统通知"/>
            </div>
        </Popup>
    </div>
</template>

<script>
    import {Popup, Form, Field, NavBar,Cell} from "vant"


    export default {
        components: {Popup, Form, Field, NavBar,Cell},
        props: {
            type: {type: String, default: "default"},
            show: {type: Boolean, default: false},
            notice: {type: Object, required: true}
        },
        data() {
            return {
                popupShow: false,
                device: {},
                alarm: {},
                data: {}
            }
        },
        computed: {},
        created(){},
        mounted() {
        },
        methods: {
            close() {
                this.$emit('panel', this.type,)
            },
            getDevice() {
                if (this.notice.id != null) {
                    this.$http.tokiot.device.get({id: this.data.deviceId})
                        .then(res => {
                            if (res) {
                                this.device = res;
                            }
                        })
                }
            },
            getAlarm() {
                if (this.notice.id != null) {
                    this.$http.tokiot.device.alarm.detail({id: this.data.alarmLogId})
                        .then(res => {
                            if (res) {
                                this.alarm = res;
                            }
                        })
                }
            },
        },
        watch: {
            show(show) {
                this.popupShow = show
            },
            notice(notice) {
                this.data = JSON.parse(notice.data)
                console.info('data', this.data)
                if (notice.type == "Install") {
                    this.getDevice();
                } else if (notice.type == "Alarm") {
                    this.getAlarm();
                }

            }
        }
    }
</script>

<style scoped>

</style>